export class IframeHeightStrategy {
  getHeight() {
    throw new Error('Method "getHeight" should be implemented')
  }
}